import { render } from "./MetricTableYear.vue?vue&type=template&id=1bb2ce04&scoped=true"
import script from "./MetricTableYear.vue?vue&type=script&lang=js"
export * from "./MetricTableYear.vue?vue&type=script&lang=js"

import "./MetricTableYear.vue?vue&type=style&index=0&id=1bb2ce04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb2ce04"]])

export default __exports__